<template>
  <div class="dialogSce" ref="date">
    <el-table ref="naisData" tooltip-effect="dark" border highlight-current-row  :data="tableData.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table">
      <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
      </el-table-column>
    </el-table>
    <!--分页器-->
    <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="tableData.length" @size-change="handleSizeChange" :page-sizes="[5, 20, 50, 100]" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import bus from './bus'
  export default {
    name: "dialogSce",
    data() {
      return {
        /*通过key刷新表格*/
        table:1,
        /*分页器的参数*/
        pageInfo: {
          currentPage: 1,
          pageSize: 5,
        },
        /*表格的最大高度*/
        tableHeight:'',
        /*表格组件渲染数组*/
        tableTitle:[
          {label:"案例编号",width:"120",prop:"caseNumber",show:true},
          {label:"图层名",width:"",prop:"laneLineType",show:true},
          {label:"#线",width:"",prop:"line",show:true},
          {label:"#点",width:"",prop:"point",show:true},
          {label:"X",width:"",prop:"coordinateX",show:true},
          {label:"Y",width:"",prop:"coordinateY",show:true},
          {label:"Z",width:"",prop:"coordinateZ",show:true}
        ],
        /*表格数据*/
        tableData: [],
      }
    },
    methods:{
      /* 分页大小切换*/
      handleSizeChange(val) {
        this.pageInfo.pageSize = val;
      },
      /*分页切换*/
      handleCurrentChange(val) {
        this.pageInfo.currentPage = val;
      },
      /*获取高度*/
      getHeight(){
        /*定义两个高度，初始高度和现在高度*/
        let nowH;
        /*延迟获取当前高度*/
        this.$nextTick(()=>{
          nowH = this.$refs.date.offsetHeight - 36;
        });
        let height = this.tableHeight;
        /*比对操作*/
        if(nowH !== height){
          this.tableHeight = nowH;
          this.table++;
        }
      }
    },
    mounted(){
      /*当真实DOM渲染完成后调用该钩子获取当前data元素的高度并保存*/
      /*在created调用会报bug因为页面初始化时vue生命周期中先虚拟DOM，此时真实的DOM还没有挂载，无法获取*/
      this.$nextTick(()=>{
        this.tableHeight = this.$refs.date.offsetHeight - 36;
      });
    },
    created(){
      /*在页面初始化时调用获取实时高度函数*/
      this.getHeight();
      /*接收数据*/
      bus.$on("sce",msg=>{
        this.tableData = msg;
      });
      /*接收案例编号*/
      bus.$on("caseNumber",msg=>{
        for(let i = 0;i < this.tableData.length;i++){
          this.tableData[i].caseNumber = msg;
        }
      })
    }
  }
</script>

<style scoped>
  .dialogSce{
    width: 99%;
    height: 100%;
  }
  .el-pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/data/dialogSce.vue